import { useAuthContext } from "@contexts/auth";
import { useProjectContext } from "@contexts/projects";
import { indexerLabel } from "@utils/indexerLabel";

export const formatNumberToCurrency = (value = 0, checkCub = true, locale = "pt-BR", currency = "BRL") => {
  const { cubBased } = useProjectContext();
  let val = value
  if (isNaN(val)) return 0
  if (cubBased && checkCub) {
    return formatNumberToLocale(checkIfCubBased(val, true))
  }
  return Number(val?.toFixed(2).replace('-0', '0')).toLocaleString(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export const formatNumberToLocale = (value = 0, locale = "pt-BR") => {
  const safeValue = Number.isFinite(value) ? value : 0
  return roundValue(safeValue).toLocaleString(locale, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export const roundValue = (value = 0) => Math.round(value * 100) / 100;

export const formatToPercentage = (value = 0) => {
  let res = (value * 100).toFixed(2)
  if (isNaN(res)) return 0
  return res
}

export const checkIfCubBased = (value, current = false) => {
  const { activeProject, cubBased } = useProjectContext();
  // const { user: { configurations: { currentCub } } } = useAuthContext();

  if (cubBased) {
    if (!current) {
      const indexerValue = activeProject.originalIndexer?.value;
      return value / (indexerValue && indexerValue !== 0 ? indexerValue : 1);
    }
    const indexerValue = activeProject.indexer?.value;
    return value / (indexerValue && indexerValue !== 0 ? indexerValue : 1);
  }
  return value

}

export const checkLabel = (string) => {
  const { activeProject, cubBased } = useProjectContext();
  if (cubBased) {
    return `${string} (${indexerLabel(activeProject)})`
  }
  return `${string} (R$)`
}

export const dateToString = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
}